export const ZENDESK_URLS = {
    HELPCENTER: "HELPCENTER",
};

export const ZENDESK_URL_MAPPING = {
    de: {
        [ZENDESK_URLS.HELPCENTER]: "https://betterspace.zendesk.com/hc/de",
    },
    en: {
        [ZENDESK_URLS.HELPCENTER]: "https://betterspace.zendesk.com/hc/de", // no en translation available
    },
};
